// Grid quantization contract shared by tracker (producer), collector's
// aggregation cron (storage), and dashboard (renderer). Changing any value
// here silently corrupts historical aggregates — treat as append-only.

// Click coordinates are element-relative (ADR 2): relX/relY in [0,1] within
// the clicked element's bounding rect, quantized to a 32x32 grid per element
// (agg_click_daily.grid_x/grid_y).
export const CLICK_GRID_SIZE = 32;

// Mouse-move samples are page-relative fractions quantized to a fixed grid:
//   gridX = clamp(floor(pageX / docWidth  * MOVE_GRID_COLS), 0, MOVE_GRID_COLS - 1)
//   gridY = clamp(floor(pageY / docHeight * MOVE_GRID_ROWS), 0, MOVE_GRID_ROWS - 1)
// The dashboard scales the grid back onto the snapshot dimensions.
export const MOVE_GRID_COLS = 64;
export const MOVE_GRID_ROWS = 256;

// Scroll dwell buckets are 5%-of-doc-height slices; dwellByBucket keys are
// "0-5", "5-10", ..., "95-100" (see event-payload.ts scrollPayloadSchema).
export const SCROLL_BUCKET_PCT = 5;

export function quantizeToGrid(fraction: number, cells: number): number {
  const cell = Math.floor(fraction * cells);
  return cell < 0 ? 0 : cell >= cells ? cells - 1 : cell;
}

// FNV-1a 32-bit, hex-encoded — used for agg_click_daily.selector_hash so
// long selectors group/compare cheaply. Pure string math: safe in Workers,
// browsers and Node alike.
export function hashSelector(selector: string): string {
  let hash = 0x811c9dc5;
  for (let i = 0; i < selector.length; i++) {
    hash ^= selector.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(16).padStart(8, "0");
}
